import type { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import type {
  BasicReference,
  Page as CMSPage,
  ContentItem,
  Website
} from '@ps/web-martech-cms-types';

import type { IspSportsAlias, Model } from '../../types';

import effects from './effects';
import selectors from './selectors';

type Optional<T, K extends keyof T> = Omit<T, K> & Partial<T>;

type CMSAlias = CMSPage['alias'];
export type Page = Omit<CMSPage, 'alias'> & { alias?: CMSAlias | IspSportsAlias };
export type Alias = NonNullable<CMSAlias> | IspSportsAlias;

export interface BasicContentItem extends BasicReference {
  title: string;
}

export type CMSState = Optional<WebsiteResponse, 'website' | 'aliases'> & {
  pathBrand?: BrandTypes;
};

export interface WebsiteResponse {
  website: Website;
  content: Record<string, ContentItem>;
  aliases: Partial<{ [key in Alias]: string }>;
}

export interface RoutesResponse {
  [key: string]: string;
}

interface CMSModel extends Model<CMSState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const defaultState = { content: {} };

const reducers = {
  setWebsite: (state: CMSState, payload: Optional<WebsiteResponse, 'website' | 'aliases'>) => ({
    ...state,
    ...payload
  }),
  addAliases: (state: CMSState, aliases: CMSState['aliases']) => ({
    ...state,
    aliases: {
      ...state.aliases,
      ...aliases
    }
  })
};

const page: CMSModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export default page;
